import { getMessages } from '../../../../../../../store/constants';

export const TIME_AT = getMessages().getText('common.time.at');
export const AUTHOR = getMessages().getText('card_form_card_author');
export const TEMPLATE_TOOLTIP = getMessages().getText('card_form_card_author_template_tooltip');
